import { render, staticRenderFns } from "./Onlinebook.vue?vue&type=template&id=56f9941c&scoped=true"
import script from "./Onlinebook.vue?vue&type=script&lang=js"
export * from "./Onlinebook.vue?vue&type=script&lang=js"
import style0 from "./Onlinebook.vue?vue&type=style&index=0&id=56f9941c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f9941c",
  null
  
)

export default component.exports